module.exports = __webpack_public_path__ + "static/media/bigHit.c45056c4.svg";